<template>
    <div>
      <div class="element-wrapper">
        <div class="element-box-tp">
          
          <div class="table-responsive">
            <vuetable ref="vuetable"
            :css="{tableClass: 'table table-padded'}"
			      :api-mode="false"
            :fields="fieldsTable"
            :per-page="perPage"
			      :data-manager="dataManager"
            pagination-path="pagination"
	          @vuetable:pagination-data="onPaginationData">
      <div slot="profissional" slot-scope="props">
        <div class="user-with-avatar">
          <imagem-profissional :idProfissional="props.rowData._id"></imagem-profissional>
          <span>{{ props.rowData.nome }}</span>
        </div>
      </div>
      <div slot="registro" slot-scope="props">
        <span>
          {{ props.rowData.tipoRegistro }} - {{props.rowData.numeroRegistro}}
        </span>
      </div>
      <div slot="status" slot-scope="props">
        <span :class="{'green': props.rowData.status === 'ATIVO', 'orange': props.rowData.status === 'INATIVO'}" class="status-pill smaller"></span><span>{{props.rowData.status}}</span>
      </div>
      <div slot="actions" slot-scope="props" class="row-actions">
        <a v-if="utilizaAgendamento && props.rowData.status === 'ATIVO'" title="Gerenciar Agenda" @click="agenda(props.rowData._id)"><i class="os-icon os-icon-calendar-time"></i></a>
        <a v-if="props.rowData.status === 'ATIVO'" title="Editar" @click="edit(props.rowData._id)"><i class="os-icon os-icon-pencil-1"></i></a>
        <a v-if="props.rowData.status === 'INATIVO'" title="Ativar" @click="ativar(props.rowData)"><i class="os-icon os-icon-check"></i></a>
        <a v-if="props.rowData.status === 'ATIVO'" title="Desativar" class="danger" @click="remove(props.rowData)"><i class="os-icon os-icon-x"></i></a>
        <a v-if="!isPF" title="Acesso ao sistema" @click="userAccess(props.rowData)"><i class="os-icon os-icon-user"></i></a>
			</div>
		</vuetable>
    <div class="dataTables_paginate paging_simple_numbers">
      <vuetable-pagination ref="pagination"
      class="pull-right"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>
          </div>
        </div>
      </div>
      
      <div class="modal fade" id="modalUserProfissional" tabindex="-1" role="dialog" aria-labelledby="modalUserProfissionalTitle" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="modalUserProfissionalTitle">Definir dados de acesso</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col col-md-6 form-group">
                  <label>Usuário</label>
                  <input required type="text" name="usr" id="usr" v-model="username" class="form-control">
                </div>
              </div>
              <div class="form-row">
                <div class="col col-md-6 form-group">
                    <label for="password">Senha</label>
                    <input required type="password" v-model="password" name="password" id="password" class="form-control mb-4 mr-sm-2 mb-sm-0" >   
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import ImagemProfissional from '@/components/shared/ImagemProfissional'
import Vuetable from 'vuetable-2'
import VuetablePagination from '@/components/shared/VueTablePaginationBootstrap'
import _ from 'lodash'
const fields = [
  {name: '__slot:profissional', title: 'Profissional', sortField: 'nome'},
  {name: '__slot:registro', title: 'Registro'},
  {name: 'especialidade.nome', title: 'Especialidade', sortField: 'especialidade.nome'},
  {name: '__slot:status', title: 'Status', sortField: 'status'},
  {name: '__slot:actions'}
]
export default {
  components: {
    ImagemProfissional,
    VuetablePagination,
    Vuetable
  },
  computed: {
    utilizaAgendamento () {
      return this.$store.getters.rede && this.$store.getters.rede.agendamento
    },
    getColumns () {
      return this.utilizaAgendamento ? ['nome', 'nr_registro', 'agenda', 'acao'] : ['nome', 'nr_registro', 'acao']
    },
    isPF () {
      return this.$store.getters.rede && this.$store.getters.rede.cpf
    }
  },
  data () {
    return {
      username: null,
      password: null,
      listProfissionais: [],
      data: [],
      fieldsTable: fields,
      perPage: 8
    }
  },
  watch: {
    data (newVal, oldVal) {
      this.$refs.vuetable.refresh()
    }
  },
  methods: {
    agenda (idCorpoClinico) {
      this.$store.dispatch('loadCorpoClinico', idCorpoClinico)
        .then(() => {
          if (!this.$store.getters.corpoClinico.tempoAtendimento) {
            alert('Necessário definir o tempo de atendimento do profissional!')
          } else {
            this.$router.push({name: 'AgendaProfissionalForm'})
          }
        })
    },
    async remove (corpoClinico) {
      if (confirm('Deseja realmente desativar o profissional?')) {
        await this.$store.dispatch('removeCorpoClinico', corpoClinico)
        this.loadList()
      }
    },
    async ativar (corpoClinico) {
      if (confirm('Deseja realmente ativar o profissional?')) {
        await this.$store.dispatch('ativarCorpoClinico', corpoClinico)
        this.loadList()
      }
    },
    edit (idCorpoClinico) {
      this.$store.dispatch('loadCorpoClinico', idCorpoClinico)
        .then(() => {
          this.$router.push({name: 'PageCadastroProfissionalForm'})
        })
    },
    async loadList () {
      this.data = await this.$store.dispatch('getCorpoClinico')
    },
    userAccess (profissional) {
      window.$('#modalUserProfissional').modal('show')
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    dataManager (sortOrder, pagination) {
      if (this.data.length < 1) return

      let local = this.data

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        console.log('orderBy:', sortOrder[0].sortField, sortOrder[0].direction)
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        )
      }

      pagination = this.$refs.vuetable.makePagination(
        local.length,
        this.perPage
      )
      console.log('pagination:', pagination)
      let from = pagination.from - 1
      let to = from + this.perPage

      return {
        pagination: pagination,
        data: _.slice(local, from, to)
      }
    },
    onActionClicked (action, data) {
      console.log('slot actions: on-click', data.name)
    }
  },
  async mounted () {
    this.$store.dispatch('setCorpoClinico', null)
    await this.loadList()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/cadastroProfissional/List.vue